<template>
    <v-data-table class="elevation-1"
                  :headers="headers"
                  :items="items"
                  hide-default-footer
                  no-data-text="No available specialists"
                  :items-per-page="-1">
        <template v-slot:item="props">
            <Item :item="props.item"
                  @click="handleItemClick">
            </Item>
        </template>
    </v-data-table>
</template>

<script>
import Item from './ClientSpecialistItem'
import _ from 'lodash'

import {mapActions, mapState, mapGetters} from 'vuex'

export default {
    name: 'List',
    props: {
        items: Array,
        progress: Boolean
    },
    components: {
        Item
    },
    data() {
        return {
            headers: [
                {
                    text: 'Name',
                    align: 'left',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: 'Position',
                    align: 'left',
                    sortable: false,
                    value: 'position'
                },
                {
                    text: 'Phone',
                    align: 'left',
                    sortable: false,
                    value: 'phone'
                },
                {
                    text: 'Email',
                    align: 'left',
                    sortable: false,
                    value: 'email'
                },
                {
                    text: 'Comment',
                    align: 'left',
                    sortable: false,
                    value: 'comment'
                }
            ]
        }
    },
    computed: {
        ...mapState('clients', {
        }),
    },
    methods: {
        handleItemClick (item) {
            this.$emit('clientSpecialistSelected', item.id)
        }
    }
}
</script>

<style scoped>

</style>